import { render, staticRenderFns } from "./EventsHorizontalCard.vue?vue&type=template&id=49244e22"
import script from "./EventsHorizontalCard.vue?vue&type=script&lang=ts"
export * from "./EventsHorizontalCard.vue?vue&type=script&lang=ts"
import style0 from "./EventsHorizontalCard.vue?vue&type=style&index=0&id=49244e22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports